import { TableCell, TableRow } from '../../../../ui-components/Table';
import { useSelector } from 'react-redux';
import { selectArtikelLoseWareList } from '../../../../../store/ArtikelLoseWare.store';
import { PropertyEntryProps } from '../types';
import { BestellpositionArtikelLoseWareView } from '../../../../types';
import ArtikelZulageMultipleAuswahl from '../../../ArtikelZulageAuswahl/ArtikelZulageMultipleAuswahl';

export const ZulageInputTableRow = ({
    bestellposition,
    disabled,
}: PropertyEntryProps<BestellpositionArtikelLoseWareView>): JSX.Element | null => {
    const artikelLoseWareList = useSelector(selectArtikelLoseWareList);
    const artikelStamm = artikelLoseWareList.find((a) => a.nummer === bestellposition.nummer);
    const artikelGruppeIdFromPosition =
        bestellposition.artikelGruppeId != null && String(bestellposition.artikelGruppeId).trim() !== ''
            ? String(bestellposition.artikelGruppeId).trim()
            : '';
    const effectiveArtikelGruppeId = artikelGruppeIdFromPosition || String(artikelStamm?.artikelGruppeId ?? '').trim();

    if (bestellposition.zulage) {
        return (
            <TableRow>
                <TableCell detail colSpan={20}>
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', paddingRight: '6rem' }}>
                        <ArtikelZulageMultipleAuswahl
                            artikelgruppeId={effectiveArtikelGruppeId}
                            werkId={bestellposition.werkId ? String(bestellposition.werkId) : undefined}
                            name={`bestellpositionenView[${bestellposition.index}].zulagenData`}
                            label="Artikelzulage"
                            disabled={disabled}
                        />
                    </div>
                </TableCell>
            </TableRow>
        );
    }
    return null;
};
